import { getTokenFromCookie } from '~/utils/getTokenFromCookie'
import { gql } from '@apollo/client'

export const GET_VIEWER = gql`
  query getViewerInfo {
    viewer {
      id
      intercomVerificationId
      city
      locationCountryCode
      avatar
      firstname
      lastname
      successfullySoldCount
      isEmployee
      hasAgreedToLatestTermsAndPrivacyPolicy
      createdAt
      email
      isPhoneVerified
      isEmailVerified
      isPartner
      facebookUserPermissions {
        handle
        granted
      }
      facebookAccount {
        friendsCount
      }
      twitterAccount {
        id
      }
      cart {
        id
      }
      locale
      accountAlerts {
        title
        url {
          url
          trackingUrl
          path
        }
        description
      }
      userDevices {
        name
      }
    }
  }
`

const getViewer = async (apolloClient, req) => {
  const token = getTokenFromCookie(req)

  try {
    const { data } = await apolloClient.query({
      query: GET_VIEWER,
      skip: !token,
    })

    if (data.viewer !== null) {
      return data.viewer
    }
  } catch {}

  return null
}

export default getViewer
